<template>
  <g>
    <path :d="'M' + B.x + ' ' + B.y + ' L' + C.x + ' ' + C.y + ' L' + D.x + ' ' + D.y + ' L' + E.x + ' ' + E.y + ' L' + A.x + ' ' + A.y + 'Z'" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <g v-for="(side, index) in sides" :key="index">
        <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#ddd" stroke-width="1"/>
        <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <rect :x="side.labelBackground.x" :y="side.labelBackground.y" :width="side.labelBackground.width" :height="side.labelBackground.height" style="fill:#fff" />
      </g>
    </g>
    <text v-for="side in sides" :key="side.id" dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="side.labelSpace.x" :y="side.labelSpace.y" class="font-weight-bold" font-size="1em">{{side.name}}</tspan>
      <tspan v-if="formComplete" :x="side.labelSpace.x" dy="1.5em" font-size="0.7em">{{side.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="side.labelSpace.x" dy="1em" font-size="0.7em">{{side.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === rand.saum.titleSaum.name">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="activeOesenArt">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === rand.hohlsaum.title.name" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
      </g>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt,
      A: {
        x: (425 - this.cosCalc(72) * 175 / this.cosCalc(36)) - 175 / this.cosCalc(36),
        y: 200 + this.sinCalc(72) * 175 / this.cosCalc(36)
      },
      B: {
        x: 75,
        y: 200
      },
      C: {
        x: 350 / 2 + 75,
        y: 200 - (this.sinCalc(36) * 175 / this.cosCalc(36))
      },
      D: {
        x: 425,
        y: 200
      },
      E: {
        x: 425 - this.cosCalc(72) * 175 / this.cosCalc(36),
        y: 200 + this.sinCalc(72) * 175 / this.cosCalc(36)
      }
    }
  },
  methods: {
    sinCalc (alpha) {
      return Math.sin(alpha * Math.PI / 180)
    },
    cosCalc (alpha) {
      return Math.cos(alpha * Math.PI / 180)
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            xStart: this.A.x + this.sinCalc(36) / this.sinCalc(54) * 15,
            xEnd: this.E.x - this.sinCalc(36) / this.sinCalc(54) * 15,
            yConst: this.A.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return this.yConst
            }
          },
          saum: 'M' + (this.A.x - 30 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.A.y - 30) + ' L' + (this.E.x + 30 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.E.y - 30),
          hohlsaum: 'M' + (this.A.x - 9 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.A.y - 9) + ' L' + (this.E.x + 9 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.E.y - 9),
          labelSpace: {
            x: 250,
            y: 435
          },
          labelBackground: {
            x: 215,
            y: 418,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.A.x,
              yStart: this.A.y + 40,
              xEnd: this.E.x,
              yEnd: this.E.y + 40
            },
            corner: {
              start: this.A.x + ',' + (this.A.y + 40) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 35) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 45),
              rotateStart: 'rotate(0, ' + this.A.x + ', ' + (this.A.y + 40) + ')',
              end: this.E.x + ',' + (this.E.y + 40) + ' ' + (this.E.x - 10) + ',' + (this.E.y + 35) + ' ' + (this.E.x - 10) + ',' + (this.E.y + 45),
              rotateEnd: 'rotate(0, ' + this.E.x + ', ' + (this.E.y + 40) + ')'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          size: Math.round(this.calcSides[1]),
          rand: this.randSides[1].type.name,
          oesenAnzahl: this.randSides[1].oesenAnzahl,
          oesenAbstand: {
            xStart: this.B.x + this.sinCalc(72) * 15 / this.sinCalc(54),
            xEnd: this.A.x + this.sinCalc(36) / this.sinCalc(54) * 15,
            yStart: this.B.y + this.sinCalc(18) * 15 / this.sinCalc(54),
            yEnd: this.A.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.A.x + 30 / this.sinCalc(72)) + ' ' + this.A.y + ' L' + (this.B.x + this.sinCalc(54) * (30 / this.sinCalc(72))) + ' ' + (this.B.y - this.sinCalc(36) * (30 / this.sinCalc(72))),
          hohlsaum: 'M' + (this.A.x + 9 / this.sinCalc(72)) + ' ' + this.A.y + ' L' + (this.B.x + this.sinCalc(54) * (9 / this.sinCalc(72))) + ' ' + (this.B.y - this.sinCalc(36) * (9 / this.sinCalc(72))),
          labelSpace: {
            x: 60,
            y: 300
          },
          labelBackground: {
            x: 25,
            y: 282,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.A.x - this.sinCalc(72) * 40,
              yStart: this.A.y + this.sinCalc(18) * 40,
              xEnd: this.B.x - this.sinCalc(72) * 40,
              yEnd: this.B.y + this.sinCalc(18) * 40
            },
            corner: {
              start: (this.A.x - this.sinCalc(72) * 40) + ',' + (this.A.y + this.sinCalc(18) * 40) + ' ' + (this.A.x - this.sinCalc(72) * 40 - 5) + ',' + (this.A.y + this.sinCalc(18) * 40 - 10) + ' ' + (this.A.x - this.sinCalc(72) * 40 + 5) + ',' + (this.A.y + this.sinCalc(18) * 40 - 10),
              rotateStart: 'rotate(-18, ' + (this.A.x - this.sinCalc(72) * 40) + ', ' + (this.A.y + this.sinCalc(18) * 40) + ')',
              end: (this.B.x - this.sinCalc(72) * 40) + ',' + (this.B.y + this.sinCalc(18) * 40) + ' ' + (this.B.x - this.sinCalc(72) * 40 - 5) + ',' + (this.B.y + this.sinCalc(18) * 40 + 10) + ' ' + (this.B.x - this.sinCalc(72) * 40 + 5) + ',' + (this.B.y + this.sinCalc(18) * 40 + 10),
              rotateEnd: 'rotate(-18, ' + (this.B.x - this.sinCalc(72) * 40) + ', ' + (this.B.y + this.sinCalc(18) * 40) + ')'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          size: Math.round(this.calcSides[2]),
          rand: this.randSides[2].type.name,
          oesenAnzahl: this.randSides[2].oesenAnzahl,
          oesenAbstand: {
            xStart: this.B.x + this.sinCalc(72) * 15 / this.sinCalc(54),
            xEnd: this.C.x,
            yStart: this.B.y + this.sinCalc(18) * 15 / this.sinCalc(54),
            yEnd: this.C.y + 15 / this.sinCalc(54),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.B.x + 30 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.B.y + 30) + ' L' + (this.C.x + this.sinCalc(54) * (30 / this.sinCalc(72))) + ' ' + (this.C.y + this.sinCalc(36) * (30 / this.sinCalc(72))),
          hohlsaum: 'M' + (this.B.x + 9 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.B.y + 9) + ' L' + (this.C.x + this.sinCalc(54) * (9 / this.sinCalc(72))) + ' ' + (this.C.y + this.sinCalc(36) * (9 / this.sinCalc(72))),
          labelSpace: {
            x: 135,
            y: 87
          },
          labelBackground: {
            x: 100,
            y: 68,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.B.x - this.sinCalc(36) * 40,
              yStart: this.B.y - this.sinCalc(54) * 40,
              xEnd: this.C.x - this.sinCalc(36) * 40,
              yEnd: this.C.y - this.sinCalc(54) * 40
            },
            corner: {
              start: (this.B.x - this.sinCalc(36) * 40) + ',' + (this.B.y - this.sinCalc(54) * 40) + ' ' + (this.B.x - this.sinCalc(36) * 40 - 5) + ',' + (this.B.y - this.sinCalc(54) * 40 - 10) + ' ' + (this.B.x - this.sinCalc(36) * 40 + 5) + ',' + (this.B.y - this.sinCalc(54) * 40 - 10),
              rotateStart: 'rotate(54, ' + (this.B.x - this.sinCalc(36) * 40) + ', ' + (this.B.y - this.sinCalc(54) * 40) + ')',
              end: (this.C.x - this.sinCalc(36) * 40) + ',' + (this.C.y - this.sinCalc(54) * 40) + ' ' + (this.C.x - this.sinCalc(36) * 40 - 5) + ',' + (this.C.y - this.sinCalc(54) * 40 + 10) + ' ' + (this.C.x - this.sinCalc(36) * 40 + 5) + ',' + (this.C.y - this.sinCalc(54) * 40 + 10),
              rotateEnd: 'rotate(54, ' + (this.C.x - this.sinCalc(36) * 40) + ', ' + (this.C.y - this.sinCalc(54) * 40) + ')'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          size: Math.round(this.calcSides[3]),
          rand: this.randSides[3].type.name,
          oesenAnzahl: this.randSides[3].oesenAnzahl,
          oesenAbstand: {
            xStart: this.C.x,
            xEnd: this.D.x - this.sinCalc(72) * 15 / this.sinCalc(54),
            yStart: this.C.y + 15 / this.sinCalc(54),
            yEnd: this.D.y + this.sinCalc(18) * 15 / this.sinCalc(54),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.D.x - 30 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.D.y + 30) + ' L' + (this.C.x - this.sinCalc(54) * (30 / this.sinCalc(72))) + ' ' + (this.C.y + this.sinCalc(36) * (30 / this.sinCalc(72))),
          hohlsaum: 'M' + (this.D.x - 9 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.D.y + 9) + ' L' + (this.C.x - this.sinCalc(54) * (9 / this.sinCalc(72))) + ' ' + (this.C.y + this.sinCalc(36) * (9 / this.sinCalc(72))),
          labelSpace: {
            x: 365,
            y: 87
          },
          labelBackground: {
            x: 330,
            y: 68,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.C.x + this.sinCalc(36) * 40,
              yStart: this.C.y - this.sinCalc(54) * 40,
              xEnd: this.D.x + this.sinCalc(36) * 40,
              yEnd: this.D.y - this.sinCalc(54) * 40
            },
            corner: {
              start: (this.C.x + this.sinCalc(36) * 40) + ',' + (this.C.y - this.sinCalc(54) * 40) + ' ' + (this.C.x + this.sinCalc(36) * 40 - 5) + ',' + (this.C.y - this.sinCalc(54) * 40 - 10) + ' ' + (this.C.x + this.sinCalc(36) * 40 + 5) + ',' + (this.C.y - this.sinCalc(54) * 40 - 10),
              rotateStart: 'rotate(126, ' + (this.C.x + this.sinCalc(36) * 40) + ', ' + (this.C.y - this.sinCalc(54) * 40) + ')',
              end: (this.D.x + this.sinCalc(36) * 40) + ',' + (this.D.y - this.sinCalc(54) * 40) + ' ' + (this.D.x + this.sinCalc(36) * 40 - 5) + ',' + (this.D.y - this.sinCalc(54) * 40 + 10) + ' ' + (this.D.x + this.sinCalc(36) * 40 + 5) + ',' + (this.D.y - this.sinCalc(54) * 40 + 10),
              rotateEnd: 'rotate(126, ' + (this.D.x + this.sinCalc(36) * 40) + ', ' + (this.D.y - this.sinCalc(54) * 40) + ')'
            }
          },
          id: 4
        },
        e: {
          name: 'e',
          size: Math.round(this.calcSides[4]),
          rand: this.randSides[4].type.name,
          oesenAnzahl: this.randSides[4].oesenAnzahl,
          oesenAbstand: {
            xStart: this.D.x - this.sinCalc(72) * 15 / this.sinCalc(54),
            xEnd: this.E.x - this.sinCalc(36) / this.sinCalc(54) * 15,
            yStart: this.D.y + this.sinCalc(18) * 15 / this.sinCalc(54),
            yEnd: this.E.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.E.x - 30 / this.sinCalc(72)) + ' ' + this.E.y + ' L' + (this.D.x - this.sinCalc(54) * (30 / this.sinCalc(72))) + ' ' + (this.D.y - this.sinCalc(36) * (30 / this.sinCalc(72))),
          hohlsaum: 'M' + (this.E.x - 9 / this.sinCalc(72)) + ' ' + this.E.y + ' L' + (this.D.x - this.sinCalc(54) * (9 / this.sinCalc(72))) + ' ' + (this.D.y - this.sinCalc(36) * (9 / this.sinCalc(72))),
          labelSpace: {
            x: 440,
            y: 300
          },
          labelBackground: {
            x: 405,
            y: 282,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.D.x + this.sinCalc(72) * 40,
              yStart: this.D.y + this.sinCalc(18) * 40,
              xEnd: this.E.x + this.sinCalc(72) * 40,
              yEnd: this.E.y + this.sinCalc(18) * 40
            },
            corner: {
              start: (this.D.x + this.sinCalc(72) * 40) + ',' + (this.D.y + this.sinCalc(18) * 40) + ' ' + (this.D.x + this.sinCalc(72) * 40 - 5) + ',' + (this.D.y + this.sinCalc(18) * 40 + 10) + ' ' + (this.D.x + this.sinCalc(72) * 40 + 5) + ',' + (this.D.y + this.sinCalc(18) * 40 + 10),
              rotateStart: 'rotate(18, ' + (this.D.x + this.sinCalc(72) * 40) + ', ' + (this.D.y + this.sinCalc(18) * 40) + ')',
              end: (this.E.x + this.sinCalc(72) * 40) + ',' + (this.E.y + this.sinCalc(18) * 40) + ' ' + (this.E.x + this.sinCalc(72) * 40 - 5) + ',' + (this.E.y + this.sinCalc(18) * 40 - 10) + ' ' + (this.E.x + this.sinCalc(72) * 40 + 5) + ',' + (this.E.y + this.sinCalc(18) * 40 - 10),
              rotateEnd: 'rotate(18, ' + (this.E.x + this.sinCalc(72) * 40) + ', ' + (this.E.y + this.sinCalc(18) * 40) + ')'
            }
          },
          id: 5
        }
      }
    }
  }
}
</script>

<style>
</style>
